import { Box } from "@mui/material";

const CameraContainer = ({ children }: { children: React.ReactNode }) => (
  <Box
    className="tw-flex tw-h-full tw-min-h-[320px] tw-w-full tw-min-w-0 tw-flex-col tw-overflow-hidden tw-rounded-xl tw-border-0 tw-bg-gtr-surface tw-text-gtr-text tw-shadow-none sm:tw-min-h-[400px]"
    sx={{
      width: "100%",
      maxWidth: 940,
      minWidth: 0,
      minHeight: { xs: 320, sm: 400 },
      height: "100%",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      border: "none",
      borderRadius: 3,
      boxShadow: "none",
    }}
  >
    {children}
  </Box>
);

export default CameraContainer;
